module.exports = __webpack_public_path__ + "img/aParty_091123_E.bc86e041.jpg";